import React from 'react';
import { choose } from '../utils/platform';
import { useLayout } from './useLayout';
import LayoutDesktop from './Layout.desktop';
import LayoutMobile from './Layout.mobile';

// Re-exported so pages can keep importing it from here.
export { GUEST_SIDE_STORAGE_KEY, NAV, BOTTOM } from './useLayout';

const LayoutView = choose(LayoutDesktop, LayoutMobile);

// App shell: all logic in useLayout; Layout.desktop / Layout.mobile only render.
export default function Layout() {
  const vm = useLayout();
  return <LayoutView vm={vm} />;
}
